export default __webpack_public_path__ + "static/media/cloud9-1.73f42d2d.png";